/**
 * Start Page Feature Module
 *
 * Registers the start-page workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { StartPageTab } from './components/StartPageTab';

// Register the start-page workspace component
registerWorkspaceComponent('start-page', StartPageTab);

// Re-export components
export { StartPageTab } from './components/StartPageTab';
